import React from 'react'
import { GoBook } from "react-icons/go";
import { IoCodeSharp } from "react-icons/io5";
import { LuLightbulb } from "react-icons/lu";
import { FaCode } from "react-icons/fa6";
import { FiDownload } from "react-icons/fi";
import { GrDocumentStore } from "react-icons/gr";
import { LuUsers } from "react-icons/lu";
import { FaRegEnvelope } from "react-icons/fa";
// import { CiStar } from "react-icons/ci";
// import { FaDownload } from "react-icons/fa6";
// import { FaExternalLinkAlt } from "react-icons/fa";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { IoIosSend } from "react-icons/io";
import { CiBank } from "react-icons/ci";
import { MdOutlineHealthAndSafety } from "react-icons/md";
import { MdOutlineShoppingCart } from "react-icons/md"
import { MdStorefront } from "react-icons/md";

import { motion } from 'framer-motion';

const Resources = () => {

  return (
    <div>
      {/* background image */}
      <div className='min-h-screen bg-cover bg-center bg-no-repeat relative overflow-hidden flex flex-col'
        style={{ backgroundImage: "url('https://th.bing.com/th/id/OIG1.9jadruRTvmFu8nqqYdgO?w=1792&h=1024&rs=1&pid=ImgDetMain')" }}>

        {/* Overlay */}
        <div className="absolute inset-0  z-0" style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}></div>

        {/* Content */}
        <div className='z-10 relative flex flex-col items-center justify-center text-center space-y-4 px-4 mt-16'>
          <motion.p
            className='text-5xl font-semibold text-[#d38f24] mb-8'
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            Discover a Wealth of Knowledge and Tools
          </motion.p>

          <motion.p
            className='text-gray-200 text-2xl md:text-4xl pb-10 max-w-5xl'
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            Your go-to destination for resources, guides, and insights tailored to diverse industries.
          </motion.p>

          <motion.p
            className='text-gray-200 text-lg md:text-xl pb-10  max-w-4xl'
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            At QualBots, we understand that our bots cater to a myriad of industries, each with unique challenges and opportunities. Our Resource Hub is designed to equip you with the knowledge, tools, and support needed to maximize
            the potential of our bots—whether you're in banking, e-commerce, healthcare, or any other sector. Dive into our comprehensive resources to enhance your understanding of how our solutions can drive success in your organization.
          </motion.p>

          {/* CTA Buttons */}

          <motion.div
            className='flex flex-wrap justify-center gap-6 pb-10'
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 1 }}
          >

            <div className='flex flex-row sm:flex-col  items-center'>

              <button className='bg-[#d38f24] text-white px-4 py-2 rounded-md hover:bg-white hover:text-[#0b1437] flex items-center space-x-2 group'>
                <GoBook className='text-white text-xl group-hover:text-[#0b1437] ' />
                <span className='text-lg'>Explore Industry Resources</span>

              </button>
            </div>

            <div className='flex flex-col items-center'>

              <button className='bg-[#d38f24] text-white px-4 py-2 rounded-md hover:bg-white hover:text-[#0b1437] flex items-center space-x-2 group'>
                <IoCodeSharp className='text-white text-xl group-hover:text-[#0b1437] ' />
                <span className='text-lg'>Visit the Developer Portal</span>

              </button>
            </div>

            <div className='flex flex-col items-center'>

              <button className='bg-[#d38f24] text-white px-4 py-2 rounded-md hover:bg-white hover:text-[#0b1437] flex items-center space-x-2 group'>
                <LuLightbulb className='text-white text-xl group-hover:text-[#0b1437] ' />
                <span className='text-lg'>Read Our Insights</span>

              </button>
            </div>

          </motion.div>

          {/* Featured resources */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 1.2 }}
          >
            <p className='text-white text-3xl font-semibold mb-8'>Featured Resources</p>

            <div className='grid grid-cols-1 md:grid-cols-3 gap-8'>

              <motion.div
                className='text-white bg-white bg-opacity-10 rounded-lg p-6 hover:bg-opacity-20 transition-all duration-400 cursor-pointer'
                whileHover={{ scale: 1.05 }}
              >
                <p className='text-2xl font-semibold mb-4'>E-commerce Chatbots</p>
                <p className='text-gray-200 text-xl'>Boost your online sales with intelligent chatbots</p>
                <a href='/' className='text-[#d38f24] text-lg mt-4 inline-block hover:underline'>Learn More</a>
              </motion.div>

              <motion.div
                className='text-white bg-white bg-opacity-10 rounded-lg p-6 hover:bg-opacity-20 transition-all duration-400 cursor-pointer'
                whileHover={{ scale: 1.05 }}
              >
                <p className='text-2xl font-semibold mb-4'>Chatbots in Banking</p>
                <p className='text-gray-200 text-xl'>Learn how chatbots are transforming the banking sector</p>
                <a href='/' className='text-[#d38f24] text-lg mt-4 inline-block hover:underline'>Learn More</a>
              </motion.div>

              <motion.div
                className='text-white bg-white bg-opacity-10 rounded-lg p-5 hover:bg-opacity-20 transition-all duration-400 cursor-pointer'
                whileHover={{ scale: 1.05 }}>
                <p className='text-2xl font-semibold mb-4'>Chatbots in Healthcare</p>
                <p className='text-gray-100 text-xl'>Improve patient care with AI-powered tools"</p>
                <a href='/' className='text-[#d38f24] text-lg mt-4 inline-block hover:underline'>Learn More</a>
              </motion.div>

            </div>

          </motion.div>

        </div>
      </div>

      {/* section 2 */}
      <div>

        <motion.div
          className='text-center'
          initial={{ opacity: 0, x: 20 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        >
          {/* <p className='text-[#d38f24] text-4xl font-semibold mt-8 mb-6 '>Our Developer Portal</p> */}
          <p className='text-[#d38f24] text-4xl font-semibold my-10'>Unlock Your Development Potential</p>
          <p className='text-[#0b1437] text-2xl max-w-2xl mx-auto font-semibold mb-8'>Access tools, APIs, and documentation to customize and integrate our bots seamlessly.</p>
          <p className='text-[#0b1437] max-w-3xl mx-auto text-xl mb-7'>Our Developer Portal is the hub for developers seeking to enhance their applications with our bots.
            Here, you will find comprehensive API documentation, SDKs, and integration guides that will help you
            leverage our technology to its fullest. Whether you are building a banking application, an e-commerce
            platform, or a healthcare solution, our developer resources will provide the support you need.
          </p>
        </motion.div>


        <div className='flex flex-col sm:flex-row gap-14 px-8 sm:px-24 mt-16'>

          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true, amount: 0.8 }}
          >
            <img src='https://cdn.pixabay.com/photo/2024/06/14/12/15/developer-8829711_640.jpg' alt='developer'
              className='rounded-lg'></img>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true, amount: 0.8 }}>

            <p className='text-[#d38f24] text-2xl font-semibold mb-4'>Key Features of the Developer Portal:</p>

            <div className="space-y-6">

              <div className='flex items-start space-x-3'>

                <FaCode className='text-[#d38f24] text-2xl flex-shrink-0 mt-0.5' />

                <div>
                  <p className=' text-xl font-semibold mb-1'>API Documentation:</p>

                  <p className='text-lg text-gray-700'> Detailed guides on how to use our APIs for seamless integration.</p>

                </div>

              </div>

              <div className='flex items-start space-x-3'>

                <FiDownload className='text-[#d38f24] text-2xl flex-shrink-0 mt-0.5' />

                <div>
                  <p className=' text-xl font-semibold mb-1'>SDK Downloads:</p>

                  <p className='text-lg text-gray-700'> Software Development Kits for various programming languages to accelerate your development process.</p>

                </div>

              </div>

              <div className='flex items-start space-x-3'>

                <GrDocumentStore className='text-[#d38f24] text-2xl flex-shrink-0 mt-0.5' />

                <div>
                  <p className=' text-xl font-semibold mb-1'>Integration Guides:</p>

                  <p className='text-lg text-gray-700'>  Step-by-step tutorials to help you integrate our bots into your existing systems.</p>

                </div>

              </div>

            </div>

            <div className='flex items-start space-x-3'>

              <LuUsers className='text-[#d38f24] text-2xl flex-shrink-0 mt-0.5' />

              <div>
                <p className=' text-xl font-semibold mb-1'>Community Forum:</p>

                <p className='text-lg text-gray-700'>Join our community of developers to share insights, ask questions, and collaborate.</p>

              </div>

            </div>

          </motion.div>

        </div>

        <motion.div
          className='mb-10 mt-5 flex items-center justify-center'
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}>

          <button className='bg-[#d38f24] text-white text-lg px-8 py-3 rounded-full hover:bg-[#0b1437] transition-colors duration-300 flex items-center space-x-2 mx-auto my-4'>
            <FaRegEnvelope className='text-white text-xl' />
            <span>Contact Us for Guidance</span>
          </button>

        </motion.div>

      </div>

      {/* Section 3 */}
      <div className='bg-white p-2 min-h-screen pt-14 pb-6'>

        <motion.p
          initial={{ opacity: 0, x: -100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className='text-4xl font-semibold text-[#d38f24] mb-8 text-center'>Tailored Resources for Every Industry
        </motion.p>

        <motion.p
          initial={{ opacity: 0, x: -100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className='text-2xl text-[#0b1437] font-semibold mb-7 max-w-3xl mx-auto'>
          Explore resources designed specifically for various sectors, including banking, healthcare, retail, and more.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, x: 100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <p className='text-xl text-gray-800 mx-auto max-w-3xl' >Understanding that each industry has distinct needs, we have curated a selection of resources to address the specific challenges and opportunities faced by different sectors.</p>

          <p className='text-xl text-gray-800 mx-auto max-w-3xl mb-12'>From case studies and white papers to industry reports, these resources will help you harness the power of our bots to drive efficiency and innovation in your field.</p>
        </motion.div>


        {/* Cards */}
        <div className='flex justify-center '>
          <div className='grid gap-10 md:grid-cols-2 lg:grid-cols-2'>

            <div className='bg-white p-5 w-full rounded-lg shadow-lg overflow-hidden transform transition-all duration-300 hover:shadow-xl border border-gray-200'>

              <div className='flex items-center mb-3'>
                <CiBank className='text-3xl stroke-1 text-[#d38f24]' />
                <p className='text-2xl font-semibold text-[#0b1437] mt-1 ml-2'>Banking Resources</p>
              </div>


              <div className='mb-2 group'>
                <span className='flex items-center p-1.5 rounded-xl transition duration-300 ease-in-out group-hover:bg-gray-100'>
                  <p className='flex-grow text-lg text-gray-800 mb-2'>Automating Customer Onboarding in Banking</p>
                  <span className='bg-white px-2 py-1 rounded-full opacity-0 group-hover:opacity-100 text-sm text-[#0b1437] ml-2 transition-opacity duration-300 ease-in-out'>Case Study</span>
                </span>

              </div>

              <div className='mb-2 group'>
                <span className='flex items-center p-1.5 rounded-xl transition duration-300 ease-in-out group-hover:bg-gray-100'>
                  <p className='flex-grow text-lg text-gray-800 mb-2'>The Future of Banking with AI</p>
                  <span className='bg-white px-2 py-1 rounded-full opacity-0 group-hover:opacity-100 text-sm text-[#0b1437] ml-2 transition-opacity duration-300 ease-in-out'>White Paper</span>
                </span>

              </div>

              <div className='mb-2 group'>
                <span className='flex items-center p-1.5 rounded-xl transition duration-300 ease-in-out group-hover:bg-gray-100'>
                  <p className='flex-grow text-lg text-gray-800 mb-2'>Implementing Chatbots for Financial Services</p>
                  <span className='bg-white px-2 py-1 rounded-full opacity-0 group-hover:opacity-100 text-sm text-[#0b1437] ml-2 transition-opacity duration-300 ease-in-out cursor-pointer'>Download</span>
                </span>

              </div>

              <button className='w-full mb-2 bg-[#0b1437]  text-white py-2 px-4 rounded-full hover:bg-[#d38f24] duration-300 flex items-center justify-center mt-6'>Explore Banking Resources</button>

            </div>

            <div className='bg-white p-5 w-full rounded-lg shadow-lg overflow-hidden transform transition-all duration-300 hover:shadow-xl border border-gray-200'>

              <div className='flex items-center mb-3'>
                <MdOutlineHealthAndSafety className='text-3xl stroke-1 text-[#d38f24] border-none' />
                <p className='text-2xl font-semibold text-[#0b1437] mt-1 ml-2'>Healthcare Resources</p>
              </div>

              <div className='mb-2 group'>
                <span className='flex items-center p-1.5 rounded-xl transition duration-300 ease-in-out group-hover:bg-gray-100'>
                  <p className='flex-grow text-lg text-gray-800 mb-2'>Enhancing Patient Engagement with Chatbots</p>
                  <span className='bg-white px-2 py-1 rounded-full opacity-0 group-hover:opacity-100 text-sm text-[#0b1437] ml-2 transition-opacity duration-300 ease-in-out'>Case Study</span>
                </span>

              </div>

              <div className='mb-2 group'>
                <span className='flex items-center p-1.5 rounded-xl transition duration-300 ease-in-out group-hover:bg-gray-100'>
                  <p className='flex-grow text-lg text-gray-800 mb-2'> Best Practices for Implementing Bots in Healthcare</p>
                  <span className='bg-white px-2 py-1 rounded-full opacity-0 group-hover:opacity-100 text-sm text-[#0b1437] ml-2 transition-opacity duration-300 ease-in-out'>White Paper</span>
                </span>

              </div>

              <div className='mb-2 group'>
                <span className='flex items-center p-1.5 rounded-xl transition duration-300 ease-in-out group-hover:bg-gray-100'>
                  <p className='flex-grow text-lg text-gray-800 mb-2'>AI in Telemedicine</p>
                  <span className='bg-white px-2 py-1 rounded-full opacity-0 group-hover:opacity-100 text-sm text-[#0b1437] ml-2 transition-opacity duration-300 ease-in-out cursor-pointer'>Download</span>
                </span>

              </div>

              <button className='w-full mb-2 bg-[#0b1437]  text-white py-2 px-4 rounded-full hover:bg-[#d38f24] duration-300 flex items-center justify-center mt-6'>Explore Healthcare Resources</button>

            </div>

            <div className='bg-white p-5 w-full rounded-lg shadow-lg overflow-hidden transform transition-all duration-300 hover:shadow-xl border border-gray-200 mb-5'>

              <div className='flex items-center mb-3'>
                <MdOutlineShoppingCart className='text-3xl stroke-1 text-[#d38f24]' />
                <p className='text-2xl font-semibold text-[#0b1437] mt-1 ml-2'>E-commerce Resources</p>

              </div>

              <div className='mb-2 group'>
                <span className='flex items-center p-1.5 rounded-xl transition duration-300 ease-in-out group-hover:bg-gray-100'>
                  <p className='flex-grow text-lg text-gray-800 mb-2'>Boosting Sales through Personalized Shopping Bots</p>
                  <span className='bg-white px-2 py-1 rounded-full opacity-0 group-hover:opacity-100 text-sm text-[#0b1437] ml-2 transition-opacity duration-300 ease-in-out'>Case Study</span>
                </span>

              </div>

              <div className='mb-2 group'>
                <span className='flex items-center p-1.5 rounded-xl transition duration-300 ease-in-out group-hover:bg-gray-100'>
                  <p className='flex-grow text-lg text-gray-800 mb-2'> Leveraging Bots for Customer Retention</p>
                  <span className='bg-white px-2 py-1 rounded-full opacity-0 group-hover:opacity-100 text-sm text-[#0b1437] ml-2 transition-opacity duration-300 ease-in-out'>White Paper</span>
                </span>

              </div>

              <div className='mb-2 group'>
                <span className='flex items-center p-1.5 rounded-xl transition duration-300 ease-in-out group-hover:bg-gray-100'>
                  <p className='flex-grow text-lg text-gray-800 mb-2'>E-commerce Automation: Strategies for Success</p>
                  <span className='bg-white px-2 py-1 rounded-full opacity-0 group-hover:opacity-100 text-sm text-[#0b1437] ml-2 transition-opacity duration-300 ease-in-out cursor-pointer'>Download</span>
                </span>

              </div>

              <button className='w-full mb-2 bg-[#0b1437]  text-white py-2 px-4 rounded-full hover:bg-[#d38f24] duration-300 flex items-center justify-center mt-6'>Explore E-commerce Resources</button>

            </div>

            <div className='bg-white p-5 w-full rounded-lg shadow-lg overflow-hidden transform transition-all duration-300 hover:shadow-xl border border-gray-200 mb-5'>

              <div className='flex items-center mb-3'>
                <MdStorefront className='text-3xl stroke-1 text-[#d38f24]' />
                <p className='text-2xl font-semibold text-[#0b1437] mt-1 ml-2'>Retail Resources</p>
              </div>


              <div className='mb-2 group'>
                <span className='flex items-center py-2 px-1.5 rounded-xl transition duration-300 ease-in-out group-hover:bg-gray-100'>
                  <p className='flex-grow text-lg text-gray-800 mb-2'>Optimizing Inventory Management with AI</p>
                  <span className='bg-white px-2 py-1 rounded-full opacity-0 group-hover:opacity-100 text-sm text-[#0b1437] ml-2 transition-opacity duration-300 ease-in-out'>Case Study</span>
                </span>

              </div>

              <div className='mb-2 group'>
                <span className='flex items-center p-1.5 rounded-xl transition duration-300 ease-in-out group-hover:bg-gray-100'>
                  <p className='flex-grow text-lg text-gray-800 mb-2'>Enhancing Customer Experience through Bots</p>
                  <span className='bg-white px-2 py-1 rounded-full opacity-0 group-hover:opacity-100 text-sm text-[#0b1437] ml-2 transition-opacity duration-300 ease-in-out'>White Paper</span>
                </span>

              </div>

              <div className='mb-2 group'>
                <span className='flex items-center p-1.5 rounded-xl transition duration-300 ease-in-out group-hover:bg-gray-100'>
                  <p className='flex-grow text-lg text-gray-800 mb-2'>The Impact of Automation in Retail</p>
                  <span className='bg-white px-2 py-1 rounded-full opacity-0 group-hover:opacity-100 text-sm text-[#0b1437] ml-2 transition-opacity duration-300 ease-in-out cursor-pointer'>Download</span>
                </span>

              </div>

              <div className='flex justify-center'>
                <button className='w-full md:w-1/2 mb-2 bg-[#0b1437]  text-white py-2 px-4 rounded-full hover:bg-[#d38f24] duration-300 flex items-center justify-center mt-6'>Explore Retail Resources</button>
              </div>

            </div>

          </div>
        </div>

      </div>

      {/* Section 4 */}

      <div className='mt-10'>

        <motion.div
          initial={{ opacity: 0, x: -100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}>

          <p className='text-4xl font-semibold text-[#d38f24] mb-8 text-center'>Real-World Success: Insights from Our Clients</p>

          <p className='text-2xl text-[#0b1437] font-semibold mb-7 max-w-3xl mx-auto'>Discover how diverse businesses are leveraging our bots to solve real-world challenges.</p>

        </motion.div>


        <motion.p
          initial={{ opacity: 0, x: 100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className='text-xl text-gray-800 mx-auto max-w-3xl mb-12'>Our case studies provide a closer look at how organizations across various sectors have successfully
          implemented our bots to drive efficiency and innovation. Gain insights from their experiences and learn how you can apply similar strategies to your business.</motion.p>


        <div className='grid grid-cols-1 md:grid-cols-3 gap-5 mb-10 mx-12'>


          <div className='bg-white  rounded-lg shadow-lg hover:shadow-2xl border overflow-hidden p-6 '>
            <p className='text-xl text-[#0b1437] font-semibold mb-2'>Revolutionizing Banking with AI-Driven Chatbots</p>
            <p className='text-lg text-[#d38f24] font-medium mb-2'>Leading Banking Institution</p>
            <p className='text-lg mb-2'> <strong className='text-lg text-[#0b1437]'>Challenge:</strong> High volume of customer inquiries leading to long wait times</p>
            <p className='text-lg mb-2'> <strong className='text-lg text-[#0b1437]'>Solution:</strong> Implementation of a 24/7 chatbot for real-time support</p>
            <p className='text-lg mb-3'> <strong className='text-lg text-[#0b1437]'>Result: </strong> 40% increase in customer satisfaction, 30% reduction in operational costs</p>
            <div className='flex justify-center'>
              <button className='text-gray-200 bg-[#0b1437] hover:bg-[#d38f24] hover:text-white p-2.5 rounded-lg'> Read the Full Case Study</button>
            </div>

          </div>

          <div className='bg-white  rounded-lg shadow-lg hover:shadow-2xl border overflow-hidden p-6 '>
            <p className='text-xl text-[#0b1437] font-semibold mb-2'>Enhancing Healthcare Delivery with AI</p>
            <p className='text-lg text-[#d38f24] font-medium mb-2'>Major Healthcare Provider</p>
            <p className='text-lg mb-2'> <strong className='text-lg text-[#0b1437]'>Challenge:</strong> Inefficient patient engagement processes in the healthcare sector</p>
            <p className='text-lg mb-2'> <strong className='text-lg text-[#0b1437]'>Solution:</strong> Development of a personalized patient engagement bot</p>
            <p className='text-lg mb-3'> <strong className='text-lg text-[#0b1437]'>Result: </strong> 50% improvement in patient response rates, streamlined appointment scheduling</p>
            <div className='flex justify-center'>
              <button className='text-gray-200 bg-[#0b1437] hover:bg-[#d38f24] hover:text-white p-2.5 rounded-lg'> Read the Full Case Study</button>
            </div>

          </div>

          <div className='bg-white  rounded-lg shadow-lg hover:shadow-2xl border overflow-hidden p-6'>
            <p className='text-xl text-[#0b1437] font-semibold mb-2'>Automating Retail Customer Service</p>
            <p className='text-lg text-[#d38f24] font-medium mb-2'>Nationwide Retail Chain</p>
            <p className='text-lg mb-2'> <strong className='text-lg text-[#0b1437]'>Challenge:</strong> Increased customer service inquiries overwhelming staff</p>
            <p className='text-lg mb-2'> <strong className='text-lg text-[#0b1437]'>Solution:</strong> Custom chatbot to handle FAQs and order tracking</p>
            <p className='text-lg mb-3'> <strong className='text-lg text-[#0b1437]'>Result: </strong> 60% of inquiries resolved automatically, improved staff focus on complex issues</p>
            <div className='flex justify-center'>
              <button className='text-gray-200 bg-[#0b1437] hover:bg-[#d38f24] hover:text-white p-2.5 rounded-lg'> Read the Full Case Study</button>
            </div>

          </div>


        </div>


      </div>

      {/* Section 5 */}

      <div className='container mx-auto bg-white mt-6'>

        <motion.p
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className='text-4xl text-[#d38f24] font-semibold text-center pt-10 mb-6'>
          Subscribe for the Latest Updates and Insights
        </motion.p>

        <div className='flex flex-col sm:flex-row items-center justify-center gap-x-10 px-10 w-full'>

          <div
            initial={{ opacity: 0, x: -100 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className='max-w-2xl'>
            <p className='text-2xl text-[#0b1437] font-semibold mb-6'>Join our newsletter for expert tips, new resources, and industry news.</p>
            <p className='text-xl'>Stay informed about the latest trends in automation and AI with our newsletter.</p>
            <p className='text-xl'>Get expert advice, resources, and insights delivered directly to your inbox, ensuring you’re always ahead in your industry.</p>
          </div>

          <div
            initial={{ opacity: 0, x: 100 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className='bg-gray-50 rounded-lg shadow-lg px-8 py-4 mb-6'>
            <p className='text-2xl text-[#0b1437] font-semibold mb-4'>Subscribe to Our Newsletter</p>

            <form className='flex flex-col'>
              <input
                type='text'
                placeholder='Enter your Name'
                className='w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none mb-2'
              />

              <input
                type='email'
                placeholder='Enter your Email'
                className='w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none mb-2'
              />

              <input
                type='text'
                placeholder='Enter your Company'
                className='w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none mb-2'
              />

              <div className='flex items-center justify-center w-full bg-[#d38f24] text-white py-3 px-4 rounded-md hover:bg-[#0b1437] transition-colors duration-300'>
                <button type='submit' className="text-lg font-semibold">
                  Subscribe
                </button>
                <IoIosSend className='text-lg ml-2' />
              </div>
            </form>

            <p className="text-sm text-gray-600 mt-4 text-center">
              By subscribing, you agree to our{" "}
              <a href="/" className="text-[#d38f24] hover:underline">Privacy Policy</a> and{" "}
              <a href="/" className="text-[#d38f24] hover:underline">Terms of Service</a>.
            </p>
          </div>

        </div>

      </div>


    </div>
  )
}

export default Resources